/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CompanyVerificationDto { 
    status?: CompanyVerificationDto.StatusEnum;
    proofUploaded?: boolean;
    proofUploadedAt?: string;
    rejectReason?: string;
}
export namespace CompanyVerificationDto {
    export type StatusEnum = 'PENDING' | 'VERIFIED' | 'REJECTED';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Verified: 'VERIFIED' as StatusEnum,
        Rejected: 'REJECTED' as StatusEnum
    };
}


